const IgnoreIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.62109 15.1185C1.62109 16.8752 1.96711 18.6147 2.63938 20.2378C3.31165 21.8608 4.29701 23.3355 5.53921 24.5777C6.7814 25.8198 8.2561 26.8052 9.87911 27.4775C11.5021 28.1498 13.2416 28.4958 14.9984 28.4958C16.7551 28.4958 18.4946 28.1498 20.1176 27.4775C21.7406 26.8052 23.2153 25.8198 24.4575 24.5777C25.6997 23.3355 26.6851 21.8608 27.3574 20.2378C28.0296 18.6147 28.3756 16.8752 28.3756 15.1185C28.3756 13.3618 28.0296 11.6222 27.3574 9.99923C26.6851 8.37622 25.6997 6.90152 24.4575 5.65932C23.2153 4.41713 21.7406 3.43177 20.1176 2.7595C18.4946 2.08722 16.7551 1.74121 14.9984 1.74121C13.2416 1.74121 11.5021 2.08722 9.87911 2.7595C8.2561 3.43177 6.7814 4.41713 5.53921 5.65932C4.29701 6.90152 3.31165 8.37622 2.63938 9.99923C1.96711 11.6222 1.62109 13.3618 1.62109 15.1185Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.63477 5.75488L24.363 24.4831"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default IgnoreIcon;
